import React, { Component } from "react";
import { Collapse, Checkbox, Slider, Select } from "antd";

const { Panel } = Collapse;
const CheckboxGroup = Checkbox.Group;
const resolutionOptions = ["High-res", "Mid-res", "Low-res"];
const fileTypeOptions = ["svg", "png", "jpg", "gif"];

export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedResolution: resolutionOptions,
      checkedFileType: fileTypeOptions,
      indeterminate: true,
    };
  }

  onChangeResolution = (checkedResolution) => {
    this.setState({
      checkedResolution,
      indeterminate:
        !!checkedResolution.length &&
        checkedResolution.length < resolutionOptions.length,
      checkAll: checkedResolution.length === resolutionOptions.length,
    });
    this.props.changeIncludedResolutions(checkedResolution);
  };

  onChangeFileType = (checkedFileType) => {
    this.setState({
      checkedFileType,
      indeterminate:
        !!checkedFileType.length &&
        checkedFileType.length < fileTypeOptions.length,
      checkAll: checkedFileType.length === fileTypeOptions.length,
    });
    this.props.changeIncludedFileTypes(checkedFileType);
  };

  onChangeRepetitionsRange = (value) => {
    this.props.changeRepetitionsRange(value);
  };

  render() {
    return (
      <div id="filters" className="pane">
        <Collapse ghost={true} defaultActiveKey={["0", "1", "2"]}>
          <Panel header="File Type">
            <CheckboxGroup
              options={fileTypeOptions}
              value={this.state.checkedFileType}
              onChange={this.onChangeFileType}
            />
          </Panel>
          <Panel header="Resolution">
            <CheckboxGroup
              options={resolutionOptions}
              value={this.state.checkedResolution}
              onChange={this.onChangeResolution}
            />
          </Panel>
          <Panel header="Repetitions">
            <Slider
              range={{ draggableTrack: true }}
              defaultValue={[0, this.props.maxNumberOfRepetitions]}
              max={this.props.maxNumberOfRepetitions}
              onChange={this.onChangeRepetitionsRange}
            />
          </Panel>
        </Collapse>
      </div>
    );
  }
}
